import { createFileRoute } from "@tanstack/react-router";

import { RequirePermission } from "@/hooks/shared/CheckAuth";
import { PayrollRunsListPage } from "@/pages/dashboard/payroll-runs/list";

export const Route = createFileRoute("/_main/dashboard/payroll-runs/")({
  component: () => (
    <RequirePermission action="payroll.read">
      <PayrollRunsListPage />
    </RequirePermission>
  ),
});
